module.exports = __webpack_public_path__ + "static/img/ir.c7f485eb.svg";